import { Dispatch, SetStateAction } from 'react'

import { AiTagSearchCondition } from '@/common/api/modules/aiTag'
import { aiTagCategoryLabel } from '@/common/app/modules/recommend/aiTag'
import { AITagCategory } from '@/common/model/recommend/aiTag'

import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import DisclosureSortRadioSelect from '@/components/view/molecules/disclosure/DisclosureSortRadioSelect'

interface Props {
  condition: AiTagSearchCondition
  setCondition: Dispatch<SetStateAction<AiTagSearchCondition>>
}

const AITagSearchConditionField = ({ condition, setCondition }: Props) => {
  return (
    <SearchConditionAreaContent>
      <div className='flex items-center justify-between'>
        <SortButtonList>
          <DisclosureSortRadioSelect
            name='category'
            currentValue={condition.category}
            choices={Object.values(AITagCategory).map((category) => ({
              name: aiTagCategoryLabel(category),
              value: category
            }))}
            setCondition={setCondition}
          >
            タグカテゴリ
          </DisclosureSortRadioSelect>
        </SortButtonList>
        <TextField
          type='search'
          size={TextBoxSize.LARGE}
          value={condition.keyword ?? ''}
          onChange={(e) =>
            setCondition((condition) => ({
              ...condition,
              page: 1,
              keyword: e.target.value || null
            }))
          }
          placeholder='タグ名で検索する'
        />
      </div>
    </SearchConditionAreaContent>
  )
}

export default AITagSearchConditionField
